import Component from 'vue-class-component';
import { BaseStore } from './base.store';
import { SystemSettingsDTO } from '../model/SystemSettingsDTO';

@Component
export class SystemStore extends BaseStore {
	timeId: number = null;
	publicatingTimeId: number = null;
	settings: SystemSettingsDTO;

	async fetchTimeVersion() {
		const timeId = parseInt(this.$route.query.csh);
		this.publicatingTimeId = await this.$systemService.fetchTimeVersion();
		this.timeId = timeId || this.publicatingTimeId;
	}

	async fetchSettings() {
		this.settings = await this.$systemService.fetchSettings();
	}
}
